"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFlyoutAlignment = exports.parseDirection = exports.parseValueFromCss = exports.getInlineStyle = void 0;
var getSelectorContent = function (cssText, selector) {
    var execResult = new RegExp(selector + "\\s*\\{(.*?)\\}", 's').exec(cssText);
    return execResult ? execResult[1] : '';
};
exports.getInlineStyle = function (inlineStyles) {
    return inlineStyles
        .replace(/&amp;/g, '&')
        .replace(/&quot;/g, '"')
        .split(';')
        .reduce(function (styles, attr) {
        var trimmedAttr = attr.trim();
        if (!trimmedAttr) {
            return styles;
        }
        var _a = trimmedAttr.split(':'), name = _a[0], value = _a[1];
        if (name && value) {
            styles[name.trim()] = value.trim().replace('px', '');
        }
        return styles;
    }, {});
};
function parseValueFromCss(cssText, selector, key, fallbackValue) {
    var rules = getSelectorContent(cssText, ".root::" + selector);
    var styles = exports.getInlineStyle(rules);
    var res = styles[key];
    if (!res) {
        return fallbackValue;
    }
    return typeof fallbackValue === 'number' ? Number.parseInt(res, 10) : res;
}
exports.parseValueFromCss = parseValueFromCss;
exports.parseDirection = function (cssText) {
    return parseValueFromCss(cssText, 'menu', 'direction', 'ltr');
};
exports.parseFlyoutAlignment = function (cssText) {
    return parseValueFromCss(cssText, 'columnsLayout', '--flyoutAlignment', 'left');
};
//# sourceMappingURL=parseCss.js.map